/**
 * Data attribute that marks the element a modal's / dialog's primary action shortcut
 * (`Cmd`/`Ctrl` + `Enter`) should activate.
 *
 * It is set by `ModalPrimaryButton` and by the confirm button of `DialogButtons`, so
 * component authors normally never have to deal with it directly.
 */
export const modalPrimaryActionAttribute = 'data-mf-primary-action';
/**
 * Props to spread onto the element that should be activated by a modal's / dialog's
 * `Cmd`/`Ctrl` + `Enter` shortcut.
 *
 * @example
 * <Button {...modalPrimaryActionProps} text="Save" onClick={handleSave} />
 */
export const modalPrimaryActionProps = { [modalPrimaryActionAttribute]: 'true' };
